function add0(m) {
    return m<10?'0'+m:String(m)
};
function dateTime(timestamp,type,breakType) {
    if (!timestamp) {
      return '';
    }
    // type 是否需要时分秒 不传表示不需要，需要传1
    // type 为2时 表示把时分秒转化为中午/晚上 （商家开通中午/晚上配送限制时用）
    //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
    let time = new Date();
    if(typeof(timestamp) == 'string') {
        if(timestamp.indexOf('T')!=-1) {
            let dates = timestamp.replace(/-/g, '/').replace('T', ' ').replace('.', ' ').split(/\/|\:|\ /)
            time = new Date(dates[0],dates[1]-1,dates[2],dates[3],dates[4],dates[5]);
            time.setTime(time.setHours(time.getHours() + 8));
        } else {
            time = new Date(timestamp.replace(/-/g, '/'));
        }
    } else {
        time = new Date(timestamp);
    }
    let year = time.getFullYear();
    let month = time.getMonth()+1;
    let date = time.getDate();
    let hour=time.getHours(); 
    let minute=time.getMinutes(); 
    let second=time.getSeconds(); 
    if(type == 1) {
        return year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hour) + ':'  + add0(minute) + ':' + add0(second);
    }else if(type == 2){
        let hms = add0(hour) + ':'  + add0(minute) + ':' + add0(second);
        if(hms == '09:00:00') {
            return year + '-' + add0(month) + '-' + add0(date) + ' ' + '中午';
        } else if(hms == '15:00:00'){
            return year + '-' + add0(month) + '-' + add0(date) + ' ' + '晚上';
        } else {
            return year + '-' + add0(month) + '-' + add0(date);
        }
    }else if(type == 4){
        let hms = add0(hour) + ':'  + add0(minute) + ':' + add0(second);
        if(hms == '09:00:00') {
            return year + '-' + add0(month) + '-' + add0(date) + ' ' + '上午';
        } else if(hms == '15:00:00'){
            return year + '-' + add0(month) + '-' + add0(date) + ' ' + '下午';
        } else {
            return year + '-' + add0(month) + '-' + add0(date);
        }
    } else {
        if(breakType == '年月日') {
            return year + '年' + add0(month) + '月' + add0(date) + '日';
        } else {
            return year + '-' + add0(month) + '-' + add0(date)
        }
    }
}
export {
    dateTime
}


// WEBPACK FOOTER //
// ./src/util/dateTime.js